<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import IconifyIcon from '@iconify/svelte'
    import moreIcon from '@iconify/icons-fa-solid/chevron-right'
    import createIcon from '@iconify/icons-fa-solid/plus'
    import {getAllConfigs} from 'src/components/cabinet/#services/gameConfig'

    getAllConfigs.send()
</script>

<svelte:head>
    <title>App Configs</title>
</svelte:head>

<MainLayout title="App Configs">
    <svelte:fragment slot="content">
        <div class="row">
            <div class="col-xl-4 col-xxl-3">
                <Link to="/app-config/create" class="card card-body app-config-card">
                    <div class="create"><IconifyIcon icon={createIcon}></IconifyIcon></div>
                    <div class="config-card-details">Create new <IconifyIcon icon={moreIcon}></IconifyIcon></div>
                </Link>
            </div>
            {#if $getAllConfigs.loading || !$getAllConfigs.hasValue}
                <div class="col-xl-4 col-xxl-3">
                    <div class="card card-body app-config-card">
                        <div class="name">Loading...</div>
                        <div class="config-card-details">Loading <IconifyIcon icon={moreIcon}></IconifyIcon></div>
                    </div>
                </div>
            {:else if $getAllConfigs.hasValue}
                {#each $getAllConfigs.value.configs as {id, name}}
                    <div class="col-xl-4 col-xxl-3">
                        <Link to="/app-config/{id}" class="card card-body app-config-card">
                            <div class="name">{name}</div>
                            <div class="config-card-details">Details <IconifyIcon icon={moreIcon}></IconifyIcon></div>
                        </Link>
                    </div>
                {/each}
            {:else if $getAllConfigs.error}
                <div class="col-xl-4 col-xxl-3">
                    <div class="card card-body app-config-card">
                        <div class="name">Error...</div>
                    </div>
                </div>
            {/if}
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .name {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 170px;
        font-size: 20px;
        color: #6c757d;
        font-weight: 500;
    }

    .create {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 170px;
        font-size: 40px;
        color: #a0a6ab;
    }

    .config-card-details {
        border-top: 1px solid #d9d9d9;
        text-align: right;
        padding-top: 15px;
        margin-top: 16px;
        color: #6c757d;
        transition: .25s;
    }

    .config-card-details :global(svg) {
        vertical-align: top;
        margin: 4px 0 0 5px;
        color: #8d9297;
    }

    :global(.app-config-card:hover) .config-card-details {
        color: #ff5d1c;
    }

    .card:hover {
        box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15), 0 2px 7px #e1e3eb;
    }

    @media(max-width: 767px) {
        .name,
        .create {
            height: 80px;
        }
    }
</style>
